import React from 'react';
import styles from './styles';
import {Input} from 'antd';
import { FormattedMessage } from 'react-intl';

const getTextInput = (props: any) => {
  return (
    <Input.TextArea {...props} type='text' style={{...styles.inputDefault, ...props.style}}>
    </Input.TextArea>
  );
};

const getTextInputWithPlaceholder = (props: any) => {
  return (
    <FormattedMessage id={props.placeholder}>
      {(p: any) => <Input.TextArea {...props} placeholder={p} type='text' style={{...styles.inputDefault, ...props.style}} />}
    </FormattedMessage>
  );
};

export const RBHTextInputArea = (props: any) => {
  return props.placeholder ? getTextInputWithPlaceholder(props) : getTextInput(props);
};

export default RBHTextInputArea;
